// @ts-nocheck
/**
 * custom-back-in-stock.js
 * Back in Stock via Klaviyo Client API
 *
 * A – Popup (Produktkarte): Glocken-Button → Popup mit Galerie, Preis, Varianten + BIS-Formular
 * B – Quick Add Modal: BIS-Formular bei ausverkaufter Variante (MutationObserver auf Button)
 * C – Produktseite Block: Ein-/Ausblenden je nach Variantenverfügbarkeit
 */
(function () {
  'use strict';

  var KLAVIYO_SITE_ID = 'WeJKuA';
  var productCache = {};

  // ─── Klaviyo API ───────────────────────────────────────────────────────────
  async function klaviyoBIS(email, variantId) {
    var res = await fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_SITE_ID,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-06-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      }
    );
    // 202 = Erfolg, 409 = bereits angemeldet (ebenfalls als Erfolg behandeln)
    if (!res.ok && res.status !== 409) throw new Error('Klaviyo ' + res.status);
  }

  // ─── Shopify Produkt-API ───────────────────────────────────────────────────
  async function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    var res = await fetch('/products/' + handle + '.js');
    if (!res.ok) throw new Error('Product not found: ' + handle);
    var data = await res.json();
    productCache[handle] = data;
    return data;
  }

  // ─── Preis formatieren ────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + '\u00a0' + currency;
    }
  }

  // ─── Shopify Bild-URL auf Zielgröße resizen ───────────────────────────────
  function shopifyImg(src, size) {
    if (!src) return '';
    // Bestehende Größen-Suffixe entfernen, neue setzen
    return src
      .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|\d*x\d+)(\.\w+)(\?|$)/i, '$1$2')
      .replace(/(\.\w+)(\?|$)/i, '_' + size + '$1$2');
  }

  // ─── Meldung anzeigen ────────────────────────────────────────────────────
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = el.className.replace(/\s*is-(success|error)/g, '') + ' is-' + type;
    el.hidden = false;
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // TEIL A – POPUP (Produktkarte)
  // ═══════════════════════════════════════════════════════════════════════════
  var popup = document.getElementById('custom-bis-popup');

  if (popup) {
    var elGallery   = document.getElementById('bis-popup-gallery');
    var elTitleLink = document.getElementById('bis-popup-title-link');
    var elPrice     = document.getElementById('bis-popup-price');
    var elVarWrap   = document.getElementById('bis-popup-variants');
    var elVarLabel  = document.getElementById('bis-popup-variant-label');
    var elVarGrid   = document.getElementById('bis-popup-variant-grid');
    var elForm      = document.getElementById('bis-popup-form');
    var elEmail     = document.getElementById('bis-popup-email');
    var elSubmit    = document.getElementById('bis-popup-submit');
    var elMsg       = document.getElementById('bis-popup-message');
    var elDetails        = popup.querySelector('.bis-popup__details');
    var currentVariantId = null;

    // Galerie-Höhe = Details-Höhe setzen (Bilder haben aspect-ratio 3:4 per CSS)
    function sizeGallery() {
      if (!elDetails) return;
      var h = elDetails.offsetHeight;
      if (h) elGallery.style.height = h + 'px';
    }

    // ── Popup öffnen ─────────────────────────────────────────────────────────
    async function openPopup(triggerBtn) {
      var handle = triggerBtn.dataset.bisProductHandle;
      var title  = triggerBtn.dataset.bisProductTitle  || '';
      var imgSrc = triggerBtn.dataset.bisProductImage  || '';

      // Zustand zurücksetzen
      elTitleLink.textContent = title;
      elTitleLink.href = '/products/' + handle;
      elPrice.textContent  = '';
      elMsg.hidden         = true;
      elMsg.className      = 'bis-popup__message';
      elEmail.value        = '';
      elSubmit.disabled    = false;
      elVarWrap.hidden     = true;
      elVarGrid.innerHTML  = '';
      currentVariantId     = null;

      // Erstes Bild sofort zeigen
      elGallery.innerHTML = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + title + '" loading="eager">'
        : '';

      // Popup einblenden
      popup.hidden = false;
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(sizeGallery, 50);

      // Vollständige Produktdaten laden
      try {
        var product  = await fetchProduct(handle);
        var variants = product.variants || [];
        var options  = product.options  || [];

        // Bildergalerie – alle Produktbilder
        // Die Shopify Storefront API (/products/handle.js) gibt images als Strings ODER Objekte zurück
        elGallery.innerHTML = '';
        (product.images || []).forEach(function (img, i) {
          var imgUrl = typeof img === 'string' ? img : (img.src || img.url || '');
          if (!imgUrl) return;
          var el = document.createElement('img');
          el.src = shopifyImg(imgUrl, '600x');
          el.alt = title;
          el.loading = i === 0 ? 'eager' : 'lazy';
          elGallery.appendChild(el);
        });
        setTimeout(sizeGallery, 50);

        // Preis des ersten ausverkauften Variants anzeigen (oder Produktpreis)
        var priceVariant = variants.find(function (v) { return !v.available; }) || variants[0];
        updatePopupPrice(priceVariant, product);

        // Varianten
        // options kann String-Array ["Size"] ODER Objekt-Array [{name:"Size",...}] sein
        var firstOpt = options[0];
        var firstOptName = typeof firstOpt === 'string' ? firstOpt : (firstOpt && firstOpt.name ? firstOpt.name : '');
        var isDefault = options.length === 1 && firstOptName.toLowerCase() === 'title';

        if (!isDefault && variants.length > 1) {
          elVarLabel.textContent = firstOptName || 'Size';
          elVarWrap.hidden = false;

          variants.forEach(function (v) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.dataset.variantId = String(v.id);
            // Bei einem Option zeige option1 (z.B. "XS"), bei mehreren den vollen Variantennamen
            btn.textContent = options.length === 1 ? (v.option1 || v.title) : v.title;
            btn.className = 'bis-popup__variant-btn' + (v.available ? ' is-available' : '');

            if (v.available) {
              btn.setAttribute('aria-disabled', 'true');
              btn.title = 'Currently available';
            }

            btn.addEventListener('click', function () {
              if (v.available) return; // Nur ausverkaufte können angemeldet werden
              elVarGrid.querySelectorAll('.bis-popup__variant-btn').forEach(function (b) {
                b.classList.remove('is-selected');
              });
              btn.classList.add('is-selected');
              currentVariantId = String(v.id);
              updatePopupPrice(v, product);
            });

            elVarGrid.appendChild(btn);
          });

          // Erste ausverkaufte Variante vorauswählen
          var firstSoldOut = variants.find(function (v) { return !v.available; });
          if (firstSoldOut) {
            var firstBtn = elVarGrid.querySelector('[data-variant-id="' + firstSoldOut.id + '"]');
            if (firstBtn) firstBtn.click();
          }
        } else {
          currentVariantId = String(variants[0] ? variants[0].id : '');
        }
      } catch (err) {
        console.error('[BIS Popup] Fehler beim Laden:', err);
      }

      elEmail.focus();
    }

    function updatePopupPrice(variant, product) {
      var price        = variant ? variant.price        : product.price;
      var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;

      if (comparePrice && comparePrice > price) {
        elPrice.innerHTML = '<s>' + formatMoney(comparePrice) + '</s>\u00a0' + formatMoney(price);
      } else if (!variant && product.price_min !== product.price_max) {
        elPrice.textContent = formatMoney(product.price_min) + '\u2013' + formatMoney(product.price_max);
      } else {
        elPrice.textContent = formatMoney(price);
      }
    }

    // ── Popup schließen ──────────────────────────────────────────────────────
    function closePopup() {
      popup.hidden = true;
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // ── Events ───────────────────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.bis-trigger-button');
      if (btn) { e.preventDefault(); openPopup(btn); }
    });

    popup.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-bis-overlay') || e.target.closest('[data-bis-close]')) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) closePopup();
    });

    elForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      var email = elEmail.value.trim();
      if (!email) return;

      if (!currentVariantId) {
        showMsg(elMsg, 'Please select a size first.', 'error');
        return;
      }

      elSubmit.disabled = true;
      try {
        await klaviyoBIS(email, currentVariantId);
        showMsg(elMsg, "DONE! WE'LL LET YOU KNOW WHEN IT´S BACK.", 'success');
        elEmail.value = '';
        setTimeout(closePopup, 3000);
      } catch (err) {
        console.error('[BIS Popup]', err);
        showMsg(elMsg, 'SOMETHING WENT WRONG. PLEASE TRY AGAIN.', 'error');
        elSubmit.disabled = false;
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // TEIL B – QUICK ADD MODAL
  // ═══════════════════════════════════════════════════════════════════════════
  var qaDialog          = document.querySelector('dialog.quick-add-modal');
  var modalPollInterval = null;
  var modalCheckTimerA  = null;
  var modalCheckTimerB  = null;
  var modalCheckRunId   = 0;

  if (qaDialog) {
    // Öffnen/Schließen via open-Attribut beobachten (zuverlässiger als childList)
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName !== 'open') return;
        if (qaDialog.hasAttribute('open')) {
          setupBisInModal(0);
        } else {
          if (modalPollInterval) { clearInterval(modalPollInterval); modalPollInterval = null; }
          if (modalCheckTimerA) { clearTimeout(modalCheckTimerA); modalCheckTimerA = null; }
          if (modalCheckTimerB) { clearTimeout(modalCheckTimerB); modalCheckTimerB = null; }
          var old = document.querySelector('#quick-add-modal-content .bis-modal-inline');
          if (old) old.remove();
        }
      });
    }).observe(qaDialog, { attributes: true, attributeFilter: ['open'] });

    // Bei jeder Options-Interaktion finale Variante nachziehen (kein Stale-State via data-option-available)
    qaDialog.addEventListener('change', function (e) {
      var radio = e.target;
      if (radio.type !== 'radio') return;
      scheduleModalVariantCheck();
    });

    // Backup: Klick auf Variant-Label (falls aria-disabled das change-Event verhindert)
    qaDialog.addEventListener('click', function (e) {
      var label = e.target.closest('.variant-option__button-label');
      if (!label) return;
      scheduleModalVariantCheck();
    });

    // Zuverlaessiger Trigger: laeuft erst nach abgeschlossener Variant-Aktualisierung
    qaDialog.addEventListener('variant:update', function () {
      scheduleModalVariantCheck();
    });
  }

  function scheduleModalVariantCheck() {
    if (modalCheckTimerA) { clearTimeout(modalCheckTimerA); modalCheckTimerA = null; }
    if (modalCheckTimerB) { clearTimeout(modalCheckTimerB); modalCheckTimerB = null; }
    modalCheckTimerA = setTimeout(checkModalVariant, 80);
    modalCheckTimerB = setTimeout(checkModalVariant, 320);
  }

  // Setup nach Dialog-Open – mit Retry falls Content noch nicht gemorpht
  function setupBisInModal(attempt) {
    var content = document.getElementById('quick-add-modal-content');
    if (!content || !content.children.length) {
      if (attempt < 8) setTimeout(function () { setupBisInModal(attempt + 1); }, 200);
      return;
    }

    var old = content.querySelector('.bis-modal-inline');
    if (old) old.remove();
    if (modalPollInterval) { clearInterval(modalPollInterval); modalPollInterval = null; }

    var pfEl     = content.querySelector('product-form-component');
    var vidInput = content.querySelector('input[name="id"]');
    if (!pfEl || !vidInput) return;

    var handleMatch = (pfEl.dataset.productUrl || '').match(/\/products\/([^?#/\s]+)/);
    if (!handleMatch) return;

    fetchProduct(handleMatch[1]).catch(function () {});
    scheduleModalVariantCheck();

    // Polling-Fallback: Horizon setzt input.value via JS-Property (kein DOM-Attribut)
    var lastVid   = vidInput.value;
    var pollCount = 0;
    modalPollInterval = setInterval(function () {
      if (++pollCount > 20) { clearInterval(modalPollInterval); modalPollInterval = null; return; }
      var vi = document.querySelector('#quick-add-modal-content input[name="id"]');
      if (!vi) return;
      var cur = vi.value;
      if (cur !== lastVid) { lastVid = cur; scheduleModalVariantCheck(); }
    }, 250);
  }

  async function checkModalVariant() {
    var runId = ++modalCheckRunId;
    var content  = document.getElementById('quick-add-modal-content');
    if (!content) return;
    var vidInput = content.querySelector('input[name="id"]');
    var pfEl     = content.querySelector('product-form-component');
    if (!vidInput || !vidInput.value || !pfEl) return;
    var m = (pfEl.dataset.productUrl || '').match(/\/products\/([^?#/\s]+)/);
    if (!m) return;
    try {
      var product = await fetchProduct(m[1]);
      if (runId !== modalCheckRunId) return;
      var variant = product.variants.find(function (v) { return String(v.id) === String(vidInput.value); });
      updateModalBis(content, String(vidInput.value), variant ? variant.available : true);
    } catch (err) { console.error('[BIS Modal]', err); }
  }

  function updateModalBis(content, vid, available) {
    var existing = content.querySelector('.bis-modal-inline');
    if (!available) {
      if (!existing) {
        injectModalBis(content, vid);
      } else {
        var form = existing.querySelector('.bis-modal-inline__form');
        if (form) form.dataset.variantId = vid;
      }
    } else {
      if (existing) existing.remove();
    }
  }

  function injectModalBis(content, variantId) {
    var anchor = content.querySelector('.buy-buttons-block');
    if (!anchor) anchor = content.querySelector('product-form-component');
    if (!anchor) anchor = content.querySelector('.product-details .group-block-content > *:last-child');
    if (!anchor) return;

    var div = document.createElement('div');
    div.className = 'bis-modal-inline';
    div.innerHTML =
      '<p class="bis-modal-inline__intro">NOTIFY ME WHEN AVAILABLE</p>' +
      '<form class="bis-modal-inline__form" data-variant-id="' + variantId + '" novalidate>' +
        '<input type="email" placeholder="YOUR EMAIL ADDRESS" autocomplete="email" required>' +
        '<button type="submit">NOTIFY ME</button>' +
        '<p class="bis-modal-inline__message" hidden></p>' +
      '</form>';

    anchor.insertAdjacentElement('beforebegin', div);

    div.querySelector('form').addEventListener('submit', async function (e) {
      e.preventDefault();
      var form      = e.currentTarget;
      var emailEl   = form.querySelector('input[type="email"]');
      var submitBtn = form.querySelector('button[type="submit"]');
      var msgEl     = form.querySelector('.bis-modal-inline__message');
      var email     = emailEl.value.trim();
      var vid       = form.dataset.variantId;

      if (!email || !vid) return;
      submitBtn.disabled = true;

      try {
        await klaviyoBIS(email, vid);
        showMsg(msgEl, "DONE! WE'LL LET YOU KNOW WHEN IT´S BACK.", 'success');
        emailEl.value = '';
      } catch (err) {
        console.error('[BIS Modal]', err);
        showMsg(msgEl, 'SOMETHING WENT WRONG. PLEASE TRY AGAIN.', 'error');
        submitBtn.disabled = false;
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // TEIL C – PRODUKTSEITE BLOCK
  // ═══════════════════════════════════════════════════════════════════════════

  // History-Patch (einmalig) für URL-basierte Variantenwechsel (pushState/replaceState)
  if (!window._bisHistoryPatched) {
    window._bisHistoryPatched = true;

    var _origPush    = history.pushState.bind(history);
    var _origReplace = history.replaceState.bind(history);

    history.pushState = function (state, title, url) {
      _origPush(state, title, url);
      if (url) document.dispatchEvent(new CustomEvent('bis:urlchange', { detail: { url: String(url) } }));
    };

    history.replaceState = function (state, title, url) {
      _origReplace(state, title, url);
      if (url) document.dispatchEvent(new CustomEvent('bis:urlchange', { detail: { url: String(url) } }));
    };

    window.addEventListener('popstate', function () {
      document.dispatchEvent(new CustomEvent('bis:urlchange', { detail: { url: window.location.href } }));
    });
  }

  function initBisBlocks() {
    document.querySelectorAll('[data-bis-block]').forEach(function (block) {
      if (block.dataset.bisInitialized) return;
      block.dataset.bisInitialized = '1';
      setupBisBlock(block);
    });
  }

  function setupBisBlock(block) {
    var form       = block.querySelector('.bis-block__form');
    var emailEl    = block.querySelector('input[type="email"]');
    var submitEl   = block.querySelector('button[type="submit"]');
    var msgEl      = block.querySelector('.bis-block__message');
    var successTxt = block.dataset.successText || "Done! We'll notify you when it's back.";
    var errorTxt   = block.dataset.errorText   || 'SOMETHING WENT WRONG. PLEASE TRY AGAIN.';
    var blockCheckTimerA = null;
    var blockCheckTimerB = null;
    var blockCheckRunId  = 0;

    if (!form) return;

    var handle = (window.location.pathname.match(/\/products\/([^?#/]+)/) || [])[1] || null;

    function setVisible(variantId, isAvailable) {
      block.dataset.variantId = String(variantId);
      block.hidden = !!isAvailable;
      if (!isAvailable) {
        if (msgEl)    { msgEl.hidden = true; msgEl.className = 'bis-block__message'; }
        if (submitEl) { submitEl.disabled = false; }
      }
    }

    async function checkVariantById(vid) {
      if (!vid || !handle) return;
      var runId = ++blockCheckRunId;
      try {
        var product = await fetchProduct(handle);
        if (runId !== blockCheckRunId) return;
        var variant = product.variants.find(function (v) { return String(v.id) === String(vid); });
        if (variant) setVisible(variant.id, variant.available);
      } catch (err) {
        console.error('[BIS Block]', err);
      }
    }

    // URL-Änderungen (pushState/replaceState)
    document.addEventListener('bis:urlchange', function (e) {
      try {
        var params = new URL(e.detail.url, window.location.origin).searchParams;
        var vid = params.get('variant');
        if (vid) checkVariantById(vid);
      } catch (err) { /* ignorieren */ }
    });

    // Variant-Picker-Options Change-Events (Horizon: radio inputs mit name="option1" etc.)
    var section = block.closest('[data-testid="product-information-details"]')
                  || block.closest('[data-section-id]');

    function scheduleBlockVariantCheck() {
      if (!section) return;
      if (blockCheckTimerA) { clearTimeout(blockCheckTimerA); blockCheckTimerA = null; }
      if (blockCheckTimerB) { clearTimeout(blockCheckTimerB); blockCheckTimerB = null; }

      blockCheckTimerA = setTimeout(function () {
        var vidInput = section.querySelector('product-form-component input[name="id"]');
        if (vidInput && vidInput.value) checkVariantById(vidInput.value);
      }, 80);

      blockCheckTimerB = setTimeout(function () {
        var vidInput = section.querySelector('product-form-component input[name="id"]');
        if (vidInput && vidInput.value) checkVariantById(vidInput.value);
      }, 320);
    }

    if (section) {
      section.addEventListener('change', function (e) {
        if (e.target.name && /^option/.test(e.target.name)) {
          scheduleBlockVariantCheck();
        }
      });

      // Klick-Events auf Variant-Buttons als zusätzlicher Trigger
      section.addEventListener('click', function (e) {
        var optionEl = e.target.closest('.variant-option__button-label, [data-option-value]');
        if (optionEl) {
          scheduleBlockVariantCheck();
        }
      });

      // Zuverlaessiger Trigger nach abgeschlossener Variant-Aktualisierung
      section.addEventListener('variant:update', function () {
        scheduleBlockVariantCheck();
      });
    }

    // Initialzustand aus Liquid-Daten setzen
    var initVid       = block.dataset.variantId;
    var initAvailable = block.dataset.variantAvailable === 'true';
    if (initVid) setVisible(initVid, initAvailable);
    scheduleBlockVariantCheck();

    // Formular absenden
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var email = emailEl ? emailEl.value.trim() : '';
      var vid   = block.dataset.variantId;
      if (!email || !vid) return;

      if (submitEl) submitEl.disabled = true;

      try {
        await klaviyoBIS(email, vid);
        showMsg(msgEl, successTxt, 'success');
        if (emailEl) emailEl.value = '';
      } catch (err) {
        console.error('[BIS Block]', err);
        showMsg(msgEl, errorTxt, 'error');
        if (submitEl) submitEl.disabled = false;
      }
    });
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBisBlocks);
  } else {
    initBisBlocks();
  }
  document.addEventListener('shopify:section:load', initBisBlocks);
})();
